import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import TopSchoolLink from "./TopSchoolLink";

const LOGO = "/brand-images/topparent-logo.webp";

// Sitemap links. Privacy points to the external TopSchool privacy policy.
const INTERNAL_LINKS = [
    { to: "/", label: "Home" },
    { to: "/how-it-works", label: "How it works" },
    { to: "/neurodiverse-play", label: "Children who learn differently" },
    { to: "/why", label: "Why TopParent" },
];
const PRIVACY_HREF = "https://topschool.ai/privacy-policy/";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-white border-t border-brand-navy/[0.08] mt-8 md:mt-12"
        >
            <div className="container-tp py-9 md:py-11">
                <div className="grid gap-9 md:gap-10 md:grid-cols-12">
                    <div className="md:col-span-7">
                        <div className="flex items-center gap-2.5 mb-4">
                            <img
                                src={LOGO}
                                alt="TopParent"
                                width="36"
                                height="36"
                                loading="lazy"
                                decoding="async"
                                className="h-9 w-9 rounded-full"
                            />
                            <span className="font-heading font-bold text-brand-navy text-[18px]">
                                TopParent
                            </span>
                        </div>
                        <p className="text-[14.5px] text-[#334155] leading-[1.6] max-w-md">
                            TopParent helps parents find simple, low-prep activities that fit
                            their child, the moment, and everyday home routines. From the{" "}
                            <TopSchoolLink /> team.
                        </p>
                        <div className="mt-4 flex items-center gap-2 text-[14px] text-[#334155]">
                            <Mail size={15} strokeWidth={1.75} />
                            <span data-testid="footer-contact">hello@topparent.ai</span>
                        </div>
                    </div>

                    <div className="md:col-span-5">
                        <p className="text-[12.5px] font-semibold text-brand-coral mb-3 tracking-wide">
                            Sitemap
                        </p>
                        <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
                            {INTERNAL_LINKS.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        className="text-[14.5px] text-[#334155] hover:text-brand-coral transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <a
                                    href={PRIVACY_HREF}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-[14.5px] text-[#334155] hover:text-brand-coral transition-colors"
                                >
                                    Privacy
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-7 pt-5 border-t border-brand-navy/[0.08] flex flex-col sm:flex-row gap-2 sm:gap-6 justify-between items-start sm:items-center">
                    <p className="text-[14px] text-[#475569]">
                        © {new Date().getFullYear()} TopParent. A product from the{" "}
                        <TopSchoolLink /> team.
                    </p>
                    <p className="text-[14px] text-[#475569]">
                        Made with care for parents and caregivers.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
